<template>
  <div class="pk" :class="{'bg':pkData.state && pkData.state!='info','pk-index':pkData.sub_type==='matching_result'}">
    <!--PK开始-->
    <pk-match
      v-if="pkData.state==='matched' || pkData.state==='matching'"
      :closeTime="closeTime"
      :pkData="pkData"
      @close="close"
      @playAudio="playAudio"
      @closeInterval="initInterval"
      ></pk-match>
    <!--PK中-->
    <pk-info  @close="close"  @closeInterval="initInterval"  v-if="pkData.state==='info'"  :pkData="pkData"></pk-info>
    <!--PK结束-->
    <pk-result  @close="close"  @closeInterval="initInterval" v-if="pkData.state==='result'" :pkData="pkData" :closeTime="closeTime"></pk-result>
    <audio ref="audio" src="/static/audio/pk.mp3"></audio>
  </div>
</template>

<script>
import pkMatch from "./pkMatch";
import pkInfo from "./pkInfo";
import pkResult from "./pkResult";
export default {
  name: "pk",
  data() {
    return {
      closeTime: 0
    };
  },
  components: {
    "pk-info": pkInfo,
    "pk-match": pkMatch,
    "pk-result": pkResult
  },
  props: ["pkData"],
  methods: {
    initInterval(time) {
      this.closeTime = time;
      this.closeTimeInterval = setInterval(() => {
        this.closeTime--;
        if (this.closeTime <= 0) {
          this.close();
        }
      }, 1000);
    },
    close() {
      clearInterval(this.closeTimeInterval);
      this.$refs.audio && this.$refs.audio.pause();
      this.$emit("closePK");
    },
    playAudio() {
      this.$refs.audio.play();
    }
  },
  beforeDestroy() {
    this.close();
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.pk {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 80;
  // pointer-events: none;
}
.pk-index{
  z-index: 81;
}
.bg {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/pk/pk.vue